// extracted by mini-css-extract-plugin
module.exports = {"sectionFieldItem":"SectionFieldItem_sectionFieldItem__2HIG_","label":"SectionFieldItem_label__1kWg7","value":"SectionFieldItem_value__jCeON"};